var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"title":"Messenger","href":"#"}},[_vm._t("default"),_vm._v(" "),(_vm.messagesCount>0)?_c('span',{staticClass:"badge badge-primary"},[_vm._v(_vm._s(_vm.messagesCount))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac59b62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messenger/CountBadge.vue
// module id = IaXf
// module chunks = 0